import { StateCreator } from 'zustand';
import { getCountry, getLocation } from '@/utils/i18n';
import * as showroomService from '@/services/showrooms.service';
import INITIAL_STATE from '../initialState';
import { IShowroom } from '../types/IShowroom';

function capitalizeLetters(label: string) {
  const capitalizeFirstLetter = str => str[0].toUpperCase() + str.slice(1);

  return label
    .split(' ')
    .filter(s => s !== '')
    .map(capitalizeFirstLetter)
    .join(' ');
}

const createShowroomSlice: StateCreator<IShowroom> = set => ({
  showroom: INITIAL_STATE.showroom,
  async getShowrooms() {
    const { data } = await showroomService.getShowrooms();
    const {
      showrooms,
      country,
      curr_header_dropdown: headerDropdown,
      curr_showroom_name_in_header_menu: curName,
    } = data;
    if (headerDropdown)
      (window as any).dataLayer.push({
        curr_header_dropdown: headerDropdown,
      });
    const store = getLocation(data.curr_showroom, showrooms);
    const VISIT_TEXT =
      store.location_name === 'Other' ? 'Virtual Appointment' : `Visit ${store.location_name} Showroom`;
    const showroomName = capitalizeLetters(curName);
    const telCode = getCountry().code === 'GB' ? '' : '1.';

    set(() => ({
      showroom: { store, country, visitText: VISIT_TEXT, telCode, headerDropdown, showroomName },
    }));
  },
  updateShowroom(id: number, name: string) {
    showroomService.updateShowroom(id).then(() => {
      localStorage['showroom_name_in_header'] = name;
      window.location.reload();
    });
  },
});

export default createShowroomSlice;
